import { BifrostBackendApi, BifrostBackendNestApi } from "../../gateways/BifrostBackendApi";
import appConfig from "../../appconfig";

const SubscriberDetailsProvider = {
	async getDetails(idpToken) {
		const idpManagementQueryParams = {
			tenantId: appConfig.tenantConfig.tenantId
		};
		const response = await BifrostBackendNestApi.get(`/subscriptions/details`, {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: idpToken
			}
		});
		if (response.data.customerId) {
			return response.data;
		}
		return BifrostBackendApi.get(`/subscriptions/details`, {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: idpToken
			}
		})
			.then(({ data }) => data);
	}
};

export default Object.freeze(SubscriberDetailsProvider);
